import { logAction } from "../../api/logApi";
import { call } from "../../funcStore";
import { recordVtuberView } from "../../utils/userPreference";

const styles = {
  videoCard: {
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    textDecoration: "none",
    color: "inherit",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    padding:10
  },
  videoCardThumbnail: {
    width: "100%",
    aspectRatio: "16 / 9",
    objectFit: "cover",
  },
  videoCardBody: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "10px 12px",
  },
  videoCardTitle: {
    margin: 0,
    fontSize: "0.9rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  videoCardChannel: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding:10
  },
  videoCardChannelIcon: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  videoCardChannelName: {
    fontSize: "1rem",
    color: "#555",
    overflow: "hidden",          /* 溢れた部分を隠す */
  textOverflow: "ellipsis",   /* 溢れた部分を「...」にする */
  whiteSpace: "nowrap" 
  },
  videoCardScore: {
    margin: 0,
    fontSize: "0.8rem",
    color: "#4b3f8f",
  },
};

function TrendingVideoCard({ video }) {
  const videoUrl = `https://www.youtube.com/watch?v=${video.video_id}`;

  const handleClick = () => {
    recordVtuberView(video.vtuber_id)
    logAction("video_click", {
      vtuberId: video.vtuberId,
      videoId: video.videoId,
      source: "trending",
    });
  };

  const navigateVtuberDetail = () => {
    recordVtuberView(video.vtuber_id)
    call(`app.navigateToDetail`, video.vtuber_id);
  };

  return (
    <div style={styles.videoCard}>
      <a href={videoUrl} target="_blank" rel="noreferrer" onClick={handleClick}>
        <img
          style={styles.videoCardThumbnail}
          src={video.thumbnail_url.replace("hqdefault", "mqdefault")}
          alt={video.title}
          loading="lazy"
        />
        <p style={styles.videoCardTitle}>{video.title}</p>
      </a>
      <div style={styles.videoCardChannel} onClick={navigateVtuberDetail}>
        <img
          style={styles.videoCardChannelIcon}
          src={video.vtuber_icon_url}
          alt={video.vtuber_name}
          loading="lazy"
        />
        <span style={styles.videoCardChannelName}>{video.vtuber_name}</span>
      </div>
    </div>
  );
}

export default TrendingVideoCard;
